import { render, staticRenderFns } from "./SEOTextWidget.vue?vue&type=template&id=06b5623d"
var script = {}
import style0 from "./SEOTextWidget.vue?vue&type=style&index=0&id=06b5623d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports